var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49341 2.29404C7.68055 2.10416 7.85128 1.93391 8.00128 1.78609C8.15091 1.93302 8.32112 2.10218 8.50765 2.29081C9.22601 3.01725 10.181 4.02697 11.1331 5.16446C12.0885 6.30575 13.0229 7.55429 13.7136 8.75932C14.4192 9.99042 14.8 11.0568 14.8 11.8635C14.8 15.5946 11.7817 18.5999 7.99995 18.5999C4.21818 18.5999 1.19995 15.5946 1.19995 11.8635C1.19995 11.0656 1.5798 10.0038 2.28606 8.77296C2.97694 7.56892 3.91169 6.31908 4.86729 5.17557C5.81969 4.03588 6.77489 3.02305 7.49341 2.29404Z",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropSimple);
export default __webpack_public_path__ + "static/media/drop-simple.3319ecc5.svg";
export { ForwardRef as ReactComponent };